<template>
<div>
  <textarea id="general" v-model="search_text" ref="search_box" rows="1" @input="autoResize" @keydown.enter.prevent="submit_form"></textarea>
  <a id="voice-micro" :class="{listening:listening}" :disabled="listening" @click="get_voice(set_text, submit_form)"></a>
  <a id="operator_y" @click="insert_operator(' Y ')">Y</a>
  <a id="operator_o" @click="insert_operator(' O ')">O</a>
  <a id="operator_no" @click="insert_operator('!')">NO</a>
  <a id="show_search_opcions" @click.stop="show_options">Opciones</a>
  <div id="search_options" v-show="options_visible" v-on-clickaway="hide_options">
    Render opciones de búsqueda
  </div>
</div>
</template>
<script>
import { directive as onClickaway } from 'vue-clickaway';
import mixins from 'common/mixins.js'
import { mapMutations } from 'vuex'

export default {
  props:{
    conversaSearch: { type: Boolean, default: false }
  },
  data() {
    return {
      options_visible: false,
      search_text: '',
      selected : false
    }
  },
  mixins: [mixins.voice],
  directives: {
    onClickaway: onClickaway,
  },
  mounted() {
    this.focus_input();
    this.$nextTick(() => this.autoResize());
    this._tabShowHandler = () => this.$nextTick(() => this.autoResize());
    document.addEventListener('shown.bs.tab', this._tabShowHandler);
  },
  beforeDestroy() {
    document.removeEventListener('shown.bs.tab', this._tabShowHandler);
  },
  methods: {
    insert_operator(operator) {
      this.search_text += operator
    },
    show_options() {
      this.options_visible = !this.options_visible
    },
    hide_options() {
      this.options_visible = false
    },
    clean() {
      this.search_text = ''
    },
    set_text(text) {
      this.search_text = text
      this.$nextTick(() => this.autoResize())
    },
    submit_form() {
      var form = this.$refs.micro.closest('form')
      form.submit();
    },
    focus_input() {
      this.$refs.search_box.focus()
    },
    autoResize() {
      const textarea = this.$refs.search_box
      if (!textarea) return
      if (textarea.offsetParent === null) return
      textarea.style.height = 'auto'
      const computed = getComputedStyle(textarea)
      const lineHeight = parseFloat(computed.lineHeight)
      const paddingTop = parseFloat(computed.paddingTop)
      const paddingBottom = parseFloat(computed.paddingBottom)
      const borderTop = parseFloat(computed.borderTopWidth)
      const borderBottom = parseFloat(computed.borderBottomWidth)
      const maxRows = 4
      const maxHeight = (lineHeight * maxRows) + paddingTop + paddingBottom + borderTop + borderBottom
      const contentHeight = textarea.scrollHeight + borderTop + borderBottom
      const newHeight = Math.min(contentHeight, maxHeight)
      textarea.style.height = newHeight + 'px'
      textarea.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden'
      const currentRows = Math.max(1, Math.round((textarea.scrollHeight - paddingTop - paddingBottom) / lineHeight))
      textarea.style.borderRadius = currentRows > 1 ? '0.3rem' : ''
    },
    ...mapMutations('conversa', ['setConversaSearch'])
  },
  watch: {
    search_text(newValue) {
      if (newValue && this.conversaSearch) {
        this.setConversaSearch(newValue)
      }
    }
  }
}

</script>